import React, { useEffect }  from 'react';
import '../style/Menu.css';
import Logo from '../img/logo_r3act.png';
import { Link } from 'react-router-dom';
import { HashLink as Link2 } from 'react-router-hash-link';
import { useAuth } from './AuthContext';

export default function Menu() {

	const { userId, setAuthUserId } = useAuth();

  useEffect(() => {
    // Hacer algo con el userId
    console.log('UserID:', userId);
  }, [userId]);

  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-dark fixed-top">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={Logo} alt="Logo" width="50" height="60" className="d-inline-block align-text-top mx-3" />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
            <i class="bi bi-list"></i>
          </button>
          <div className="collapse navbar-collapse mx-4" id="navbarTogglerDemo02">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/" className="nav-link me-2" activeClassName="active">Inicio</Link>
              </li>
              <li className="nav-item">
                <Link to="productos" className="nav-link me-2">Productos</Link>
              </li>
              <li className="nav-item">
								<Link2 to="/#contacto" className="nav-link">Contacto</Link2>
								{/* <Link to="contacto" className="nav-link">Contacto</Link> */}
                {/* <a href="#contacto" className="nav-link">Contacto</a> */}
              </li>
            </ul>
            <div className="d-flex">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item me-2">
                  <Link to="login" className="nav-link btn btn-login px-1">{userId !== null ? userId.split('@')[0] : "Iniciar Sesión"}</Link>
                </li>
                <li className="nav-item">
                  <Link to="carrito" className="nav-link me-2">
                    <i class="bi bi-cart3"></i>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="buscar" className="nav-link">
                    <i class="bi bi-search"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}


